import { Injectable, inject } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { Query, SubscriptionQueryResult } from '@interfaces/schema';

/**
 * Subscription plans service.
 */
@Injectable()
export class SubscriptionListPlanService {
  private readonly apollo = inject(Apollo);

  /**
   * Fetch Subscription Plans.
   *
   * @returns {Observable<SubscriptionQueryResult>} Orders.
   */
  fetch(): Observable<SubscriptionQueryResult> {
    const query = gql`
      query SubscriptionList(
        $where: SubscriptionQueryFilter
        $sort: SubscriptionQuerySortBy
      ) {
        Subscription {
          findAll(where: $where, sort: $sort) {
            count
            results {
              id
              title
              code
              type
              productId
              planIncludes
              planIncludesV2 {
                position
                code
                title
                report_type
                features
                content {
                  label
                  detail
                }
              }
              description
              shortDescription
              price
              totalDiscount
              totalPrice
              showOnShop
              position
              tags
              offer
              tagline
              abbreviation
              dailyPrice
              icon
              totalDailyPrice
            }
          }
        }
      }
    `;
    const variables = {
      where: {
        showOnShop: true
      },
      sort: {
        position: 'ASC'
      }
    };
    return this.apollo
      .query<Query>({ query, variables })
      .pipe(
        map(
          ({ data }) => data?.Subscription?.findAll as SubscriptionQueryResult
        )
      );
  }
}
